module.exports = __webpack_public_path__ + "img/upload.98595a8b.png";